/* 2026 mobile product page (ok-pdp2). Mobile only; everything degrades to the plain theme if this file fails. */
(() => {
  'use strict';
  const mobile = window.matchMedia('(max-width: 767px)');
  const FREE = 3500; // free U.S. ground shipping threshold, in cents
  const money = c => '$' + (Math.max(0, c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/, ',');
  let cartTotal = null;
  let cartIds = [];
  // Keep the free-shipping line in step with the cart: re-read it after any cart change made on
  // this page (UpCart drawer, Frequently Bought Together, quick add), when the page is shown again
  // from the back button, and when the tab comes back into view.
  const shipUpdaters = [];
  // Theme previews only: Shopify's preview bar (old or new style) covers the bottom of the screen.
  // Find whatever fixed element sits at the bottom edge and report how much of the screen it covers.
  const isPreview = () => !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') ||
    !!document.querySelector('#preview-bar-iframe, #PBarNextFrameWrapper, #PBarNextFrame');
  function previewLift() {
    if (!isPreview()) return 0;
    const H = window.innerHeight;
    let top = H;
    document.querySelectorAll('#preview-bar-iframe, #PBarNextFrameWrapper, #PBarNextFrame').forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.height > 0 && r.top > H * 0.5 && r.top < top) top = r.top;
    });
    [0.3, 0.5].forEach(fx => {
      let el = document.elementFromPoint(Math.round(window.innerWidth * fx), H - 2);
      while (el && el !== document.body && el !== document.documentElement) {
        if (el.closest('[data-ok2-sticky]')) break;
        if (getComputedStyle(el).position === 'fixed') {
          const r = el.getBoundingClientRect();
          if (r.top > H * 0.6 && r.top < top) top = r.top;
          break;
        }
        el = el.parentElement;
      }
    });
    return Math.max(0, Math.round(H - top));
  }
  window.__ok2previewLift = previewLift;

  // Diagnostics for phone testing: add ?okdebug=1 (or &okdebug=1) to the page URL.
  if (/[?&]okdebug=1/.test(location.search)) {
    window.__ok2err = window.__ok2err || [];
    window.addEventListener('error', e => window.__ok2err.push((e.message || 'error') + ' @' + String(e.filename || '').split('/').pop() + ':' + e.lineno));
    window.addEventListener('unhandledrejection', e => window.__ok2err.push('promise: ' + (e.reason && e.reason.message || e.reason)));
    const box = document.createElement('pre');
    box.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:2147483647;margin:0;padding:6px 8px;background:rgba(0,0,0,.82);color:#7f7;font:11px/1.35 monospace;white-space:pre-wrap;pointer-events:none;max-height:45vh;overflow:hidden';
    const tick = () => {
      if (!box.isConnected && document.body) document.body.appendChild(box);
      const s = document.querySelector('[data-ok2-sticky]');
      const root = document.querySelector('.ok-pdp2');
      const a = root && root.querySelector('.product-single__form [data-add-to-cart], .product-single__form .add-to-cart');
      const pv = document.getElementById('preview-bar-iframe');
      const R = el => { if (!el) return 'none'; const r = el.getBoundingClientRect(); return Math.round(r.top) + '/' + Math.round(r.bottom) + ' h' + Math.round(r.height); };
      const cs = s && getComputedStyle(s);
      box.textContent = [
        'ok2 v80  w' + innerWidth + ' h' + innerHeight + ' mobile=' + mobile.matches + ' y=' + Math.round(scrollY),
        'root=' + !!root + ' ready=' + (root && root.dataset.ok2Ready) + ' atc=' + R(a),
        'sticky=' + (s ? s.className.replace('ok-mobile-only ', '') : 'MISSING') + ' in=' + (s && s.parentElement.tagName) + ' rect=' + R(s),
        s ? 'disp=' + cs.display + ' vis=' + cs.visibility + ' z=' + cs.zIndex + ' tf=' + cs.transform + ' bottom=' + cs.bottom : '',
        'previewbar=' + R(pv) + ' role=' + (window.Shopify && Shopify.theme && Shopify.theme.role) + ' calc=' + previewLift() + ' lift=' + (document.body && document.body.style.getPropertyValue('--ok2-lift')),
        'errors: ' + (window.__ok2err.slice(-4).join(' | ') || 'none')
      ].join('\n');
    };
    setInterval(tick, 700);
  }
  let cartTimer = null;
  function cartChanged() {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(() => loadCart().then(() => shipUpdaters.forEach(f => f())), 250);
  }
  const isCartWrite = url => /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ''));
  if (window.fetch && !window.fetch.__ok2) {
    const f0 = window.fetch;
    const f1 = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url);
      const p = f0.apply(this, arguments);
      if (isCartWrite(url)) p.then(cartChanged, cartChanged);
      return p;
    };
    f1.__ok2 = true;
    window.fetch = f1;
  }
  if (window.XMLHttpRequest) {
    const open0 = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) {
      if (isCartWrite(url)) this.addEventListener('loadend', cartChanged);
      return open0.apply(this, arguments);
    };
  }
  window.addEventListener('pageshow', e => { if (e.persisted) cartChanged(); });
  // Fallback: the cart icon's count changes whenever the cart does.
  document.addEventListener('DOMContentLoaded', () => {
    const icon = document.getElementById('HeaderCartTrigger');
    if (icon && 'MutationObserver' in window) new MutationObserver(cartChanged).observe(icon, {subtree: true, childList: true, characterData: true});
  });
  window.addEventListener('focus', cartChanged);
  const usd = !(window.Shopify && Shopify.currency && Shopify.currency.active && Shopify.currency.active !== 'USD');

  function loadCart() {
    return fetch('/cart.js', {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}})
      .then(r => r.ok ? r.json() : null)
      .then(c => {
        if (c && typeof c.total_price === 'number') {
          cartTotal = c.total_price;
          cartIds = (c.items || []).map(i => String(i.variant_id));
        }
      })
      .catch(() => {});
  }

  function setup(root) {
    if (root.dataset.ok2Ready) return;
    root.dataset.ok2Ready = '1';
    document.body.classList.add('ok2-page');
    const select = root.querySelector('[data-product-select]');
    const json = root.querySelector('[data-variant-json]');
    let variants = [];
    try { variants = JSON.parse(json ? json.value || json.textContent : '[]'); } catch (e) { variants = []; }
    const qtyInput = root.querySelector('.js-qty__num');
    const atc = root.querySelector('.product-single__form [data-add-to-cart], .product-single__form .add-to-cart');
    const buytype = root.querySelector('[data-ok2-buytype]');
    const sticky = root.querySelector('[data-ok2-sticky]');
    const state = {sub: false};
    let freqPaint = null;

    const current = () => {
      const id = select ? String(select.value) : '';
      return variants.find(v => String(v.id) === id) || variants[0] || null;
    };
    const subPrice = v => {
      if (!v || !v.selling_plan_allocations || !v.selling_plan_allocations.length) return null;
      const planInput = root.querySelector('.product-single__form input[name="selling_plan"]');
      const planId = planInput && planInput.value;
      const a = v.selling_plan_allocations.find(x => String(x.selling_plan_id) === String(planId)) || v.selling_plan_allocations[0];
      return a ? a.price : null;
    };
    const qty = () => Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    const unitPrice = () => {
      const v = current();
      if (!v) return 0;
      if (!v.available) return v.price; // a sold-out size can't be subscribed to
      const s = state.sub ? subPrice(v) : null;
      return s == null ? v.price : s;
    };
    // ---- back in stock: our own "notify me" button. AMP's app adds its own <button id="BIS_trigger">,
    // which we hide on this design; tapping ours presses AMP's button so AMP opens its signup form.
    const ampButton = () => [...document.querySelectorAll('#BIS_trigger')].find(b => !b.classList.contains('ok2-bis'));
    let bisWaiting = false;
    function openBis() {
      if (bisWaiting) return;
      const btn = root.querySelector('.ok2-bis');
      const label = btn && btn.querySelector('span');
      const old = label && label.textContent;
      let tries = 0;
      const done = () => { bisWaiting = false; if (btn) btn.removeAttribute('aria-busy'); if (label && old) label.textContent = old; };
      const go = () => {
        const b = ampButton();
        if (b) { done(); b.click(); return; }
        if (tries === 0) { bisWaiting = true; if (btn) btn.setAttribute('aria-busy', 'true'); if (label) label.textContent = 'Opening the sign-up form\u2026'; }
        if (++tries < 32) { setTimeout(go, 250); return; }
        // The sign-up app never loaded (slow connection or a blocker): offer email on the page.
        done();
        const v = current();
        const t = document.querySelector('h1');
        const subject = 'Back in stock request: ' + (t ? t.textContent.trim() : '') + (v && variants.length > 1 ? ' (' + (v.public_title || v.title) + ')' : '');
        let msg = root.querySelector('.ok2-bis-fallback');
        if (!msg && btn) {
          msg = document.createElement('p');
          msg.className = 'ok-mobile-only ok2-bis-fallback';
          msg.setAttribute('role', 'status');
          btn.insertAdjacentElement('afterend', msg);
        }
        if (msg) msg.innerHTML = 'The sign-up form didn\u2019t load. <a href="mailto:info@ourkidsasd.com?subject=' + encodeURIComponent(subject) + '">Email us</a> and we\u2019ll let you know when it\u2019s back.';
      };
      go();
    }
    function initBis() {
      if (!atc || root.querySelector('.ok2-bis')) return;
      const a = document.createElement('button');
      a.type = 'button';
      a.className = 'ok-mobile-only ok2-bis';
      a.hidden = true;
      a.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 10a6 6 0 0 1 12 0c0 4.5 1.6 6 2 6.5H4c.4-.5 2-2 2-6.5z" fill="#e3effa"/><path d="M10 19.5a2 2 0 0 0 4 0"/></svg><span>Notify me when it\u2019s back in stock</span>';
      a.addEventListener('click', e => { e.preventDefault(); openBis(); });
      const row = atc.closest('.product-single__form') || atc.parentElement;
      row.insertAdjacentElement('afterend', a);
    }
    function paintBis() {
      const a = root.querySelector('.ok2-bis');
      const v = current();
      const soldOut = !!(v && !v.available);
      if (a) a.hidden = !soldOut;
      root.classList.toggle('ok2-soldout', soldOut && !!a);
      const fb = root.querySelector('.ok2-bis-fallback');
      if (fb && !soldOut) fb.remove();
      // Point to a size that is in stock (single-option products only).
      let alt = root.querySelector('.ok2-alt');
      const wraps = root.querySelectorAll('.ok-variant-block .variant-wrapper');
      const avail = variants.find(x => x.available);
      if (!a || !soldOut || !avail || wraps.length !== 1) { if (alt) alt.hidden = true; return; }
      const name = avail.public_title || avail.title;
      if (!alt) {
        alt = document.createElement('p');
        alt.className = 'ok-mobile-only ok2-alt';
        alt.innerHTML = '<span class="ok2-oos-ic" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#167a43" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9" fill="#e6f6ec"/><path d="M8 12.5l2.6 2.6L16 9.6"/></svg></span><span class="ok2-oos-txt"><span data-ok2-alt-text></span><button type="button" data-ok2-alt-go></button></span>';
        (root.querySelector('.ok2-bis-fallback') || a).insertAdjacentElement('afterend', alt);
        alt.querySelector('[data-ok2-alt-go]').addEventListener('click', () => {
          const target = variants.find(x => x.available);
          if (!target) return;
          const input = [...wraps[0].querySelectorAll('input')].find(i => i.value === target.option1);
          const label = input && (root.querySelector('label[for="' + input.id + '"]') || input.nextElementSibling);
          if (label) label.click(); else if (input) input.click();
        });
      }
      alt.querySelector('[data-ok2-alt-text]').textContent = name + ' is in stock.';
      alt.querySelector('[data-ok2-alt-go]').textContent = 'Switch to ' + name;
      alt.hidden = false;
    }
    // ---- another size is sold out: a quiet line under the size buttons with a one-tap "notify me" ----
    const sizeWraps = () => [...root.querySelectorAll('.ok-variant-block .variant-wrapper')];
    function paintOos() {
      const wraps = sizeWraps();
      let el = root.querySelector('.ok2-oos');
      const v = current();
      const out = variants.filter(x => !x.available);
      const show = wraps.length === 1 && variants.length > 1 && v && v.available && out.length > 0 && out.length < variants.length;
      root.classList.toggle('ok2-has-oos', !!show);
      if (!show) { if (el) el.hidden = true; return; }
      if (!el) {
        el = document.createElement('p');
        el.className = 'ok-mobile-only ok2-oos';
        el.innerHTML = '<span class="ok2-oos-ic" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1479bd" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15z" fill="#e3f0fa"/><path d="M10 20.5a2 2 0 0 0 4 0"/></svg></span><span class="ok2-oos-txt"><span data-ok2-oos-text></span><button type="button" data-ok2-oos-go>Notify me when it\u2019s back</button></span>';
        wraps[0].insertAdjacentElement('afterend', el);
        el.querySelector('[data-ok2-oos-go]').addEventListener('click', () => {
          const target = variants.find(x => !x.available);
          if (!target) return;
          const val = target.option1;
          const input = [...wraps[0].querySelectorAll('input')].find(i => i.value === val);
          const label = input && (root.querySelector('label[for="' + input.id + '"]') || input.nextElementSibling);
          if (label) label.click(); else if (input) input.click();
          setTimeout(openBis, 350);
        });
      }
      const names = out.map(x => x.public_title || x.title);
      const txt = names.length === 1 ? names[0] + ' is sold out.'
        : names.length === 2 ? names[0] + ' and ' + names[1] + ' are sold out.'
        : 'Some sizes are sold out.';
      el.querySelector('[data-ok2-oos-text]').textContent = txt;
      el.hidden = false;
    }
    try { initBis(); } catch (err) { (window.__ok2err = window.__ok2err || []).push('bis: ' + err.message); }
    // Screen readers: announce stock changes, and name the size group by its visible heading.
    try {
      root.querySelectorAll('[data-ok2-stock]').forEach(el => { el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite'); });
      const fs = root.querySelector('.ok-variant-block fieldset.variant-input-wrap');
      if (fs && variants.length > 1 && !/[a-z]/i.test((fs.querySelector('legend') || {}).textContent || '') || /^\s*title\s*$/i.test((fs.querySelector('legend') || {}).textContent || '')) fs.setAttribute('aria-label', 'Choose a size');
    } catch (err) {}
    // Sticky bar first, so a failure anywhere below can't stop it.
    try { initSticky(); } catch (err) { (window.__ok2err = window.__ok2err || []).push('sticky: ' + err.message); }

    // ---- per-variant text (per serving, servings, stock, points, toggle prices) ----
    let subBeforeSoldOut = false;
    function update() {
      const v = current();
      if (!v) return;
      if (buytype && rcInputs()) {
        if (!v.available && state.sub) { subBeforeSoldOut = true; choose('onetime'); }
        else if (v.available && subBeforeSoldOut) { subBeforeSoldOut = false; choose('subscription'); }
      }
      root.querySelectorAll('[data-ok2-v]').forEach(el => { el.hidden = el.dataset.ok2V !== String(v.id); });
      if (usd) root.querySelectorAll('[data-ok2-servings]').forEach(el => {
        const n = parseFloat(el.dataset.ok2Servings);
        if (el.dataset.ok2V === String(v.id) && n > 0) el.textContent = money(Math.round(unitPrice() / n)) + ' per serving';
      });
      root.querySelectorAll('[data-ok2-stock]').forEach(el => {
        el.classList.toggle('ok2-stock--out', !v.available);
        const t = el.querySelector('[data-ok2-stock-text]');
        if (t) t.textContent = v.available ? 'In stock' : 'Sold out';
      });
      root.querySelectorAll('[data-ok2-points]').forEach(el => { el.textContent = Math.floor(unitPrice() / 100); });
      const sp = subPrice(v);
      if (usd) root.querySelectorAll('[data-ok2-price-one]').forEach(el => { el.textContent = money(v.price); });
      if (sp != null && usd) {
        const pct = Math.round((v.price - sp) * 100 / v.price);
        root.querySelectorAll('[data-ok2-price-sub]').forEach(el => { el.textContent = money(sp); });
        root.querySelectorAll('[data-ok2-save]').forEach(el => { el.textContent = 'save ' + pct + '%'; el.hidden = pct <= 0; });
      }
      updateShip();
      paintBis();
      try { paintOos(); } catch (err) { (window.__ok2err = window.__ok2err || []).push('oos: ' + err.message); }
      updateSticky();
      updateFactsImage();
    }

    // ---- free shipping progress ----
    // Write the shipping message with its last word and the (i) glued together, so the (i)
    // never drops onto a line by itself.
    function setShip(line, html) {
      const box = line.closest('.ok2-ship');
      const btn = box && box.querySelector('.ok2-i');
      line.innerHTML = html.replace(/([^\s>]+)((?:<\/b>)?)\s*$/, '<span class="ok2-nw">$1</span>$2');
      const nw = line.querySelector('.ok2-nw');
      if (btn && nw) nw.appendChild(btn);
    }
    function updateShip() {
      const line = root.querySelector('[data-ok2-ship-text]');
      if (!line) return;
      const v = current();
      // A sold-out size can't ship, so say nothing about shipping for it.
      const box = line.closest('.ok2-ship');
      if (box) box.style.display = v && !v.available ? 'none' : '';
      if (!v || cartTotal == null || !usd) { setShip(line, 'Free U.S. ground shipping on $35+'); return; }
      // If this item is already in the cart, the cart total already includes it.
      const inCart = cartIds.includes(String(v.id));
      const after = cartTotal + (inCart ? 0 : unitPrice() * qty());
      setShip(line, after >= FREE
        ? (cartTotal >= FREE ? 'Your cart already gets <b>free U.S. ground shipping</b>'
          : cartTotal > 0 ? 'With your cart, you get <b>free U.S. ground shipping</b>'
          : 'You get <b>free U.S. ground shipping</b>')
        : '<b>' + money(FREE - after) + '</b> away from <b>free U.S. ground shipping</b>');
    }

    // ---- purchase type toggle driving the ReCharge widget ----
    function rcInputs() {
      const w = root.querySelector('recharge-subscription-widget');
      const r = w && w.shadowRoot;
      if (!r) return null;
      const one = r.querySelector('input[value="onetime"]');
      const sub = r.querySelector('input[value="subscription"]');
      return one && sub ? {one, sub, root: r} : null;
    }
    function paintToggle() {
      if (!buytype) return;
      const sched = root.querySelector('[data-ok2-sched]');
      if (sched) {
        const pct = +sched.dataset.save || 0;
        sched.textContent = state.sub ? 'Ships on your schedule. Skip or cancel anytime.'
          : pct > 0 ? 'Subscribe to save ' + pct + '%. Skip or cancel anytime.'
          : 'Subscribe for easy repeat deliveries. Skip or cancel anytime.';
      }
      if (freqPaint) freqPaint();
      buytype.querySelectorAll('[data-ok2-type]').forEach(b => {
        const on = (b.dataset.ok2Type === 'subscription') === state.sub;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
    }
    function readWidget() {
      const i = rcInputs();
      if (!i) return;
      const next = !!i.sub.checked;
      if (next !== state.sub) { state.sub = next; paintToggle(); update(); }
    }
    function choose(type) {
      const i = rcInputs();
      if (!i) return;
      const target = type === 'subscription' ? i.sub : i.one;
      if (!target.checked) target.click();
      state.sub = type === 'subscription';
      paintToggle();
      setTimeout(update, 60);
    }
    if (buytype) {
      let tries = 0;
      const wait = setInterval(() => {
        const i = rcInputs();
        if (i) {
          clearInterval(wait);
          state.sub = !!i.sub.checked;
          buytype.hidden = false;
          root.classList.add('ok2-rc-ready');
          paintToggle();
          update();
          i.root.addEventListener('change', () => setTimeout(readWidget, 0), true);
          i.root.addEventListener('click', () => setTimeout(readWidget, 0), true);
          try { initFreq(); } catch (err) { (window.__ok2err = window.__ok2err || []).push('freq: ' + err.message); }
        } else if (++tries > 40) {
          clearInterval(wait); // widget never appeared: keep ReCharge's own controls
        }
      }, 150);
      buytype.addEventListener('click', e => {
        const b = e.target.closest('[data-ok2-type]');
        if (b) choose(b.dataset.ok2Type);
      });
      buytype.addEventListener('keydown', e => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
        e.preventDefault();
        choose(state.sub ? 'onetime' : 'subscription');
        const on = buytype.querySelector('[aria-checked="true"]');
        if (on) on.focus();
      });
    }

    // ---- delivery frequency: make the choice deliberate (design options, off unless chosen) ----
    // 'bold' restyles ReCharge's dropdown; 'pills' shows every interval as a button.
    function initFreq() {
      const mode = (location.search.match(/[?&]okfreq=(pills|bold|off)/) || [])[1] || root.dataset.ok2Freq || 'bold';
      if (mode === 'off') return;
      if (!mode) return;
      const widget = root.querySelector('recharge-subscription-widget');
      if (!widget) return;
      root.classList.add('ok2-freq--' + mode);
      const getSelect = () => {
        const sp = widget.shadowRoot && widget.shadowRoot.querySelector('rc-selling-plans');
        return sp && sp.shadowRoot ? sp.shadowRoot.querySelector('select') : null;
      };
      let wasSub = state.sub;
      if (mode === 'bold') {
        freqPaint = () => {
          if (state.sub && !wasSub) {
            widget.classList.remove('ok2-freq-pulse');
            void widget.offsetWidth;
            widget.classList.add('ok2-freq-pulse');
          }
          wasSub = state.sub;
        };
        return;
      }
      const box = document.createElement('div');
      box.className = 'ok2-freq';
      box.hidden = true;
      box.innerHTML = '<p class="ok2-freq-h" id="Ok2FreqH">How often should we send it?</p><div class="ok2-freq-opts" role="radiogroup" aria-labelledby="Ok2FreqH"></div><p class="ok2-freq-hint"></p>';
      widget.insertAdjacentElement('afterend', box);
      const opts = box.querySelector('.ok2-freq-opts');
      const hint = box.querySelector('.ok2-freq-hint');
      const build = sel => {
        const items = [...sel.options].map(o => {
          const t = o.textContent.replace(/\s+/g, ' ').trim();
          const m = t.match(/^(.*?)(?::\s*(.+))?$/);
          return {value: o.value, interval: (m && m[1] || t).trim(), save: (m && m[2] || '').trim()};
        });
        const sameSave = items.every(x => x.save === items[0].save);
        opts.innerHTML = '';
        items.forEach(x => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'ok2-freq-opt';
          b.setAttribute('role', 'radio');
          b.dataset.value = x.value;
          b.innerHTML = '<span class="ok2-freq-every">Every</span><span class="ok2-freq-int"></span>' + (!sameSave && x.save ? '<span class="ok2-freq-save"></span>' : '');
          b.querySelector('.ok2-freq-int').textContent = x.interval;
          if (!sameSave && x.save) b.querySelector('.ok2-freq-save').textContent = x.save;
          opts.appendChild(b);
        });
      };
      const paintSel = sel => {
        opts.querySelectorAll('.ok2-freq-opt').forEach(b => {
          const on = b.dataset.value === sel.value;
          b.setAttribute('aria-checked', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
        });
        const v = current();
        const sv = v && root.querySelector('[data-ok2-v="' + v.id + '"][data-ok2-servings]');
        const n = sv ? parseFloat(sv.dataset.ok2Servings) : 0;
        hint.textContent = n > 0 ? 'This size has ' + Math.round(n) + ' servings.' : '';
        hint.hidden = !(n > 0);
      };
      let retry = 0;
      freqPaint = () => {
        const sel = getSelect();
        const show = state.sub && !!sel && sel.options.length > 1;
        box.hidden = !show;
        // ReCharge draws its plan list a moment after Subscribe is picked: check again shortly.
        if (state.sub && !sel && retry < 25) { retry++; setTimeout(freqPaint, 120); return; }
        retry = 0;
        if (!show) return;
        if (opts.children.length !== sel.options.length) build(sel);
        paintSel(sel);
      };
      opts.addEventListener('click', e => {
        const b = e.target.closest('.ok2-freq-opt');
        const sel = getSelect();
        if (!b || !sel) return;
        sel.value = b.dataset.value;
        sel.dispatchEvent(new Event('input', {bubbles: true, composed: true}));
        sel.dispatchEvent(new Event('change', {bubbles: true, composed: true}));
        paintSel(sel);
        setTimeout(update, 60);
      });
      opts.addEventListener('keydown', e => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
        e.preventDefault();
        const list = [...opts.querySelectorAll('.ok2-freq-opt')];
        const i = list.findIndex(b => b.getAttribute('aria-checked') === 'true');
        const next = list[(i + (e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 1) + list.length) % list.length];
        if (next) { next.click(); next.focus(); }
      });
      // ReCharge renders the plan list a moment after Subscribe is picked.
      let n = 0;
      const t = setInterval(() => { freqPaint(); if (++n > 30 || (opts.children.length && !box.hidden)) clearInterval(t); }, 200);
      root.addEventListener('change', () => setTimeout(() => freqPaint && freqPaint(), 80));
    }

    // ---- BEST VALUE badge on the biggest size saving ----
    (function bestValue() {
      let best = null, bestPct = 0;
      root.querySelectorAll('.ok-variant-block .variant-input').forEach(el => {
        const s = el.querySelector('.ok2-save');
        const m = s && /(\d+)/.exec(s.textContent);
        const pct = m ? +m[1] : 0;
        if (pct > bestPct) { bestPct = pct; best = el; }
      });
      if (best && !best.querySelector('.ok2-best')) {
        const b = document.createElement('span');
        b.className = 'ok2-best ok-mobile-only';
        b.textContent = 'BEST VALUE';
        best.appendChild(b);
        // Row layout shows the badge right after the size name instead (see .ok2-best-in in ok-pdp2.css)
        const name = best.querySelector('.lab_var_title');
        if (name && !name.querySelector('.ok2-best-in')) {
          const t = document.createElement('span');
          t.className = 'ok2-best-in ok-mobile-only';
          t.textContent = 'BEST VALUE';
          name.appendChild(t);
        }
      }
    })();

    // ---- Supplement Facts card image (same label the gallery link opens) ----
    function updateFactsImage() {
      const card = root.querySelector('[data-ok2-facts]');
      if (!card) return;
      const link = root.querySelector('[data-ok-facts-link]');
      const btn = card.querySelector('[data-ok2-facts-open]');
      const img = card.querySelector('[data-ok2-facts-img]');
      const href = link && !link.hidden && link.getAttribute('href');
      const ok = href && href !== '#' && !href.startsWith('#');
      if (btn && img) {
        const small = ok ? href.replace(/([?&])width=\d+/, '$1width=900') : '';
        if (ok && img.getAttribute('src') !== small) img.setAttribute('src', small);
        btn.hidden = !ok;
      }
      if (card.hasAttribute('data-ok2-needs-image')) card.hidden = !ok;
    }
    root.addEventListener('click', e => {
      const f = e.target.closest('[data-ok2-facts-open]');
      if (f) { const link = root.querySelector('[data-ok-facts-link]'); if (link) link.click(); }
      const more = e.target.closest('[data-ok2-more]');
      if (more) {
        const body = document.getElementById(more.getAttribute('aria-controls'));
        const open = more.getAttribute('aria-expanded') !== 'true';
        if (body) body.classList.toggle('ok2-clamped', !open);
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.querySelector('span').textContent = open ? 'Show less' : 'Read full description';
      }
      const chipsMore = e.target.closest('[data-ok2-chips-more]');
      if (chipsMore) {
        const box = chipsMore.closest('.ok2-chips');
        if (box) box.classList.add('ok2-chips--open');
        chipsMore.remove();
      }
      const det = e.target.closest('[data-ok2-open-details]');
      if (det) {
        const d = document.querySelector(det.getAttribute('href'));
        if (d) { e.preventDefault(); d.open = true; d.scrollIntoView({behavior: 'smooth', block: 'center'}); }
      }
    });

    // ---- About: clamp long descriptions ----
    root.querySelectorAll('[data-ok2-clamp]').forEach(body => {
      body.classList.add('ok2-clamped');
      requestAnimationFrame(() => {
        const more = root.querySelector('[data-ok2-more][aria-controls="' + body.id + '"]');
        if (body.scrollHeight > body.clientHeight + 24) { if (more) more.hidden = false; }
        else body.classList.remove('ok2-clamped');
      });
    });

    // ---- bottom sheets: close on backdrop tap ----
    root.querySelectorAll('.ok2-sheet').forEach(d => {
      d.addEventListener('click', e => { if (e.target === d) d.close(); });
    });

    // ---- screen readers: DOM order follows the visual order of the buy box (phones) ----
    try {
      const vb = root.querySelector('.ok-variant-block');
      const box = vb && vb.parentElement;
      if (box && mobile.matches && getComputedStyle(box).display.includes('flex')) {
        const kids = [...box.children];
        const ord = kids.map((k, i) => ({k, i, o: parseInt(getComputedStyle(k).order, 10) || 0}));
        const sorted = ord.slice().sort((a, b) => a.o - b.o || a.i - b.i);
        if (sorted.some((x, i) => x.k !== kids[i]) && !box.querySelector('iframe')) {
          sorted.forEach(x => box.appendChild(x.k));
        }
      }
    } catch (err) { (window.__ok2err = window.__ok2err || []).push('order: ' + err.message); }

    // ---- sticky add to cart ----
    function stickyParts() {
      const v = current();
      if (!v) return {price: '', mode: '', sub: ''};
      const plans = buytype && !buytype.hidden;
      const multi = variants.length > 1;
      const q = v.available && qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      const base = multi ? (v.public_title || v.title) : (plans ? (state.sub ? 'Subscription' : 'One-time') : '');
      return {
        price: usd ? money(unitPrice() * q) : '',
        mode: multi && plans && state.sub && v.available ? 'Subscription' : '',
        sub: q > 1 ? (base ? q + ' \u00d7 ' + base : 'Qty ' + q) : base
      };
    }
    function updateSticky() {
      if (!sticky) return;
      const parts = stickyParts();
      const p = sticky.querySelector('[data-ok2-sticky-price]');
      const s = sticky.querySelector('[data-ok2-sticky-sub]');
      if (p) p.textContent = parts.price;
      if (s) s.textContent = parts.sub;
      const m = sticky.querySelector('[data-ok2-sticky-mode]');
      if (m) m.textContent = parts.mode;
      const b = sticky.querySelector('[data-ok2-sticky-atc]');
      if (b && atc) {
        const v = current();
        const soldOut = !!(v && !v.available);
        b.disabled = soldOut ? false : atc.disabled;
        b.classList.toggle('ok2-sticky-atc--notify', soldOut);
        const label = atc.querySelector('[data-add-to-cart-text]');
        const l = b.querySelector('[data-ok2-sticky-label]');
        const text = soldOut ? 'Notify me' : (label ? label.textContent : atc.textContent).trim() || 'Add to cart';
        if (l) l.textContent = text; else b.textContent = text;
      }
    }
    function initSticky() {
    if (sticky && atc) {
      let shown = false;
      const show = on => {
        if (on === shown) return;
        shown = on;
        sticky.classList.toggle('ok2-sticky--on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        sticky.querySelectorAll('button').forEach(b => { b.tabIndex = on ? 0 : -1; });
        document.body.classList.toggle('ok2-sticky-shown', on);
      };
      // Live at the end of <body> so no transformed ancestor can trap position:fixed (iOS).
      if (sticky.parentElement !== document.body) document.body.appendChild(sticky);
      // Checked on every scroll frame, so fast flicks and jump links can't skip past it.
      let queued = false;
      const check = () => {
        queued = false;
        // When the size is sold out the Add to cart button is hidden; watch the notify button instead.
        let anchor = atc;
        if (!atc.getBoundingClientRect().height) { const bis = root.querySelector('.ok2-bis'); if (bis && !bis.hidden) anchor = bis; }
        const r = anchor.getBoundingClientRect();
        const past = r.height > 0 ? r.bottom < 0 : false;
        // Shopify's theme preview bar sits at the bottom of the screen; keep the bar above it.
        const lift = previewLift();
        sticky.style.bottom = lift ? lift + 'px' : '';
        sticky.classList.toggle('ok2-sticky--lifted', lift > 0);
        document.body.style.setProperty('--ok2-lift', lift + 'px');
        show(mobile.matches && past);
      };
      const queue = () => { if (!queued) { queued = true; requestAnimationFrame(check); } };
      window.addEventListener('scroll', queue, {passive: true});
      window.addEventListener('resize', queue, {passive: true});
      if ('IntersectionObserver' in window) new IntersectionObserver(queue).observe(atc);
      setTimeout(queue, 1500);
      sticky.addEventListener('click', e => {
        if (e.target.closest('[data-ok2-sticky-atc]')) {
          const v = current();
          if (v && !v.available) { openBis(); return; }
          atc.click(); setTimeout(() => loadCart().then(updateShip), 1500);
        }
        if (e.target.closest('[data-ok2-change]')) {
          const box = root.querySelector('.product-grid__content');
          if (box) box.scrollIntoView({behavior: mobile.matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto', block: 'start'});
          const pick = root.querySelector('.ok-variant-block input:checked') || root.querySelector('.ok-variant-block input');
          if (pick) setTimeout(() => { try { pick.focus({preventScroll: true}); } catch (_) {} }, 500);
        }
      });
    }
    }

    // ---- review links jump to the reviews card ----
    root.addEventListener('click', e => {
      const j = e.target.closest('[data-ok2-jump]');
      if (!j) return;
      const t = document.getElementById('ok2-reviews') || document.getElementById('stamped-main-widget');
      if (t) { e.preventDefault(); t.scrollIntoView({behavior: 'smooth', block: 'start'}); }
    });

    // ---- events ----
    root.addEventListener('change', () => setTimeout(update, 0));
    root.addEventListener('variantChange', () => setTimeout(update, 0));
    if (qtyInput) { qtyInput.addEventListener('input', () => { updateShip(); updateSticky(); }); qtyInput.addEventListener('change', updateSticky); }
    root.addEventListener('click', e => {
      if (e.target.closest('.js-qty__adjust')) setTimeout(() => { updateShip(); updateSticky(); }, 0);
      if (atc && e.target.closest('.product-single__form [type="submit"]')) setTimeout(() => loadCart().then(updateShip), 1500);
    });
    shipUpdaters.push(updateShip);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) cartChanged(); });
    if (mobile.matches) loadCart().then(update);
    update();
  }

  // ---- move Stamped reviews up, right under the product and its Common questions (mobile only) ----
  function arrange() {
    if (!mobile.matches) return;
    const root = document.querySelector('.ok-pdp2');
    if (!root) return;
    const mainSection = root.closest('.shopify-section');
    if (!mainSection) return;
    let anchor = mainSection;
    const stamped = document.getElementById('stamped-main-widget');
    const stampedSection = stamped && stamped.closest('.shopify-section');
    if (stampedSection && stampedSection !== mainSection) {
      stampedSection.classList.add('ok2-reviews-wrap');
      if (!document.getElementById('ok2-reviews')) {
        const h = document.createElement('div');
        h.className = 'ok2-card-head ok2-reviews-head';
        h.id = 'ok2-reviews';
        h.innerHTML = '<span class="ok2-badge ok2-badge--sun ok2-badge--sm"><svg class="ok2-ic" viewBox="0 0 20 20" aria-hidden="true"><path d="M10 1.8l2.5 5.2 5.7.8-4.1 4 1 5.7L10 14.8l-5.1 2.7 1-5.7-4.1-4 5.7-.8z" fill="#ffab00"/></svg></span><h2>Reviews</h2>';
        stamped.parentNode.insertBefore(h, stamped);
      }
      tidyDetails(root);
      // Reviews go after the product, and after any old detail tabs that are still shown (for example "Allergen Info").
      const details = document.querySelector('.shopify-section.product-full-width.ok2-details-keep');
      const after = details && details.compareDocumentPosition(mainSection) & Node.DOCUMENT_POSITION_PRECEDING ? details : mainSection;
      if (after.nextElementSibling !== stampedSection) after.after(stampedSection);
      anchor = stampedSection;
    }
    tidyDetails(root);
    fbt(root);
    gallery(root);
    // Common questions stay at the end of the product section, so they come before the reviews.
  }

  // The old product-details section: hide the parts the new cards replace, keep any other tabs
  // (for example "Glutathione Research"), and hide the section if nothing is left.
  function tidyDetails(root) {
    const sec = document.querySelector('.shopify-section.product-full-width');
    if (!sec || sec.dataset.ok2Tidy) return;
    sec.dataset.ok2Tidy = '1';
    const card = root.querySelector('[data-ok2-facts]');
    const factsShown = card && !card.hidden;
    const replaced = ['allergen information', 'suggested use', 'description', 'product details'];
    if (factsShown) replaced.push('supplement facts');
    if (factsShown && card.querySelector('#Ok2Allergens')) replaced.push('allergen info', 'allergens', 'allergen');
    let left = 0;
    sec.querySelectorAll('.product-block').forEach(b => {
      const trig = b.querySelector('.collapsible-trigger');
      const t = (trig ? trig.textContent : '').trim().toLowerCase();
      const isDesc = b.classList.contains('ok-description');
      const isRefrig = t.includes('refrigerated shipping');
      const emptyFacts = t === 'supplement facts' && !b.querySelector('table, img');
      if (isDesc || isRefrig || emptyFacts || !t || replaced.includes(t)) b.classList.add('ok2-gone');
      else left++;
    });
    sec.classList.add(left ? 'ok2-details-keep' : 'ok2-details-none');
  }

  // Frequently Bought Together: copy each product photo into its row and use sentence case for the title.
  function fbt(root) {
    const box = root.querySelector('.cbb-frequently-bought-container');
    if (!box) return;
    const title = box.querySelector('.cbb-frequently-bought-title');
    if (title && /Frequently Bought Together/.test(title.textContent)) title.textContent = 'Frequently bought together';
    const imgs = [...box.querySelectorAll('.cbb-frequently-bought-product-image')];
    box.querySelectorAll('.cbb-frequently-bought-selector-list > li').forEach((li, i) => {
      const src = imgs[i] && imgs[i].style.backgroundImage;
      let t = li.querySelector('.ok2-fbt-thumb');
      if (!src) return;
      if (!t) { t = document.createElement('span'); t.className = 'ok2-fbt-thumb'; t.setAttribute('aria-hidden', 'true'); li.insertBefore(t, li.children[1] || null); }
      if (t.style.backgroundImage !== src) t.style.backgroundImage = src;
    });
  }

  // Photo thumbnails under the main image (tap to jump). Uses the gallery's own slider.
  function gallery(root) {
    const wrap = root.querySelector('.ok-media-gallery');
    const strip = root.querySelector('[data-ok2-thumbs]');
    if (!wrap || !strip || strip.dataset.ok2Wired) return;
    const slider = wrap.querySelector('.product-slideshow');
    const fl = slider && window.Flickity && Flickity.data(slider);
    if (!fl) return;
    strip.dataset.ok2Wired = '1';
    const paint = () => {
      const i = fl.selectedIndex;
      strip.querySelectorAll('.ok2-thumb').forEach(b => {
        const idx = +b.dataset.ok2Index;
        const on = b.classList.contains('ok2-thumb--more') ? i >= idx : i === idx;
        b.setAttribute('aria-current', on ? 'true' : 'false');
      });
    };
    strip.addEventListener('click', e => {
      const b = e.target.closest('.ok2-thumb');
      if (b) fl.select(+b.dataset.ok2Index);
    });
    fl.on('select', paint);
    paint();
  }

  // Viewer (design B): product name and Photos / Supplement Facts tabs in the header.
  const DOC_IC = '<svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" aria-hidden="true"><rect x="4.5" y="2.5" width="15" height="19" rx="2.5" fill="#e3effa" stroke="#1d4f6b" stroke-width="1.8"/><path d="M8 7h8M8 10.5h8M8 13.5h5" stroke="#1d4f6b" stroke-width="1.6"/></svg>';
  function viewerHeader() {
    const v = document.querySelector('.ok-image-viewer.pswp--open, .ok-facts-viewer.pswp--open');
    if (!v) return;
    const head = v.querySelector('.ok-facts-viewer__heading');
    const h2 = head && head.querySelector('h2');
    if (!h2) return;
    const box = h2.parentElement;
    const root = document.querySelector('.ok-pdp2');
    const isFacts = /supplement facts/i.test(h2.textContent || '');
    let t = box.querySelector('.ok2-vtitle');
    if (!t) {
      t = document.createElement('div');
      t.className = 'ok2-vtitle';
      const name = root && root.querySelector('.ok2-title');
      t.textContent = name ? name.textContent.trim() : (h2.textContent || '');
      box.insertBefore(t, box.firstChild);
    }
    let tabs = box.querySelector('.ok2-vtabs');
    const factsLink = root && root.querySelector('[data-ok-facts-link]');
    const hasFacts = factsLink && !factsLink.hidden;
    const photos = root ? root.querySelectorAll('.product-main-slide').length : 0;
    if (!tabs) {
      tabs = document.createElement('div');
      tabs.className = 'ok2-vtabs';
      tabs.setAttribute('role', 'tablist');
      tabs.innerHTML = '<button type="button" role="tab" data-ok2-vtab="photos">Photos' + (photos ? ' (' + photos + ')' : '') + '</button>' +
        (hasFacts ? '<button type="button" role="tab" data-ok2-vtab="facts">' + DOC_IC + 'Supplement Facts</button>' : '');
      box.appendChild(tabs);
      tabs.addEventListener('click', e => {
        const b = e.target.closest('[data-ok2-vtab]');
        if (!b || b.getAttribute('aria-selected') === 'true') return;
        const want = b.dataset.ok2Vtab;
        const api = window.okPdpViewer;
        const base = u => String(u || '').split('?')[0].replace(/^https?:/, '');
        // Same viewer: jump straight to the photo (no closing and reopening).
        if (api && !api.factsOnly) {
          let idx = -1;
          if (want === 'facts' && factsLink) idx = api.srcs.findIndex(x => base(x) === base(factsLink.getAttribute('href')));
          if (want === 'photos') idx = 0;
          if (idx >= 0) { api.goTo(idx); setTimeout(viewerHeader, 50); return; }
        }
        // Otherwise swap viewers behind a white cover so the page never flashes through.
        const cover = document.createElement('div');
        cover.className = 'ok2-vcover';
        document.body.appendChild(cover);
        setTimeout(() => cover.remove(), 900);
        const close = v.querySelector('.ok-facts-viewer__close');
        if (close) close.click();
        setTimeout(() => {
          if (want === 'facts') { if (factsLink) factsLink.click(); return; }
          const slider = root && root.querySelector('.product-slideshow');
          const fl = slider && window.Flickity && Flickity.data(slider);
          if (fl) fl.select(0, false, true);
          const zoom = root && root.querySelector('.ok-media-controls__zoom');
          if (zoom) zoom.click();
        }, 60);
      });
    }
    tabs.querySelectorAll('[data-ok2-vtab]').forEach(b => {
      const on = (b.dataset.ok2Vtab === 'facts') === isFacts;
      if (b.getAttribute('aria-selected') !== String(on)) b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }
  if ('MutationObserver' in window) {
    let pending = false;
    new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; if (document.querySelector('.pswp--open')) viewerHeader(); });
    }).observe(document.documentElement, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class']});
  }

  function start() {
    document.querySelectorAll('.ok-pdp2').forEach(setup);
    arrange();
    // Stamped renders late; re-arrange once it has built its widget.
    let n = 0;
    const t = setInterval(() => { arrange(); if (++n > 20) clearInterval(t); }, 500);
  }
  document.addEventListener('shopify:section:load', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();

/* Reviews: after changing page, bring the first review fully into view (Stamped stops partway into a card). */
document.addEventListener('click', e => {
  const a = e.target.closest && e.target.closest('.ok2-reviews-wrap .stamped-pagination a');
  if (!a || !window.matchMedia('(max-width: 767px)').matches) return;
  setTimeout(() => {
    const list = document.querySelector('.ok2-reviews-wrap #stamped-reviews-tab, .ok2-reviews-wrap .stamped-reviews');
    if (!list) return;
    const top = list.getBoundingClientRect().top + scrollY - 12;
    window.scrollTo({top, behavior: 'smooth'});
  }, 900);
}, true);
